import axios from "axios";
import { getTimeInfoUrl } from "config/apiRoot";
import {
  applyBrokerTimeZoneFromTimeInfo,
  isUsableIanaTimeZone,
} from "utils/dateFormats";

function resolveTimeInfoRequestUrl() {
  const configured = getTimeInfoUrl();
  if (/^https?:\/\//i.test(configured)) return configured;
  if (String(configured).startsWith("/")) {
    return `${window.location.origin}${configured}`;
  }
  const base = String(axios.defaults.baseURL || "").replace(/\/+$/, "");
  if (base) return `${base}/${String(configured).replace(/^\/+/, "")}`;
  return `${window.location.origin}/api/v1/common/TimeInfo`;
}

/** One public TimeInfo GET (no axios interceptors / crypto). */
export async function loadBrokerTimeZoneFromApi() {
  const url = resolveTimeInfoRequestUrl();
  const ctrl = typeof AbortController !== "undefined" ? new AbortController() : null;
  const timer = setTimeout(() => ctrl?.abort(), 4000);
  try {
    const res = await fetch(url, {
      method: "GET",
      credentials: "include",
      signal: ctrl?.signal,
      headers: { Accept: "application/json" },
    });
    if (!res.ok) return "";
    const data = await res.json();
    const tz = applyBrokerTimeZoneFromTimeInfo(data);
    return isUsableIanaTimeZone(tz) ? tz : "";
  } catch {
    return "";
  } finally {
    clearTimeout(timer);
  }
}
